import { render, staticRenderFns } from "./DashboardSendCountComponent.vue?vue&type=template&id=3d9870a4&scoped=true&"
import script from "./DashboardSendCountComponent.vue?vue&type=script&lang=js&"
export * from "./DashboardSendCountComponent.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSendCountComponent.vue?vue&type=style&index=0&id=3d9870a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9870a4",
  null
  
)

export default component.exports